export const environment = {
  production: true,
  googleMapsApiKey: 'AIzaSyCDBneaa_d_tQC5EVMD_q0IIXILyZlrvAE'
};
